export default __webpack_public_path__ + "static/media/helpCenterWheel.47d9b03e.svg";